(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5606],{

/***/ 99491:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/install-service-cart-icon.d2fc242a.svg","height":62,"width":62});

/***/ }),

/***/ 59066:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/tooltip-questionmark.1d97c4ec.svg","height":24,"width":16});

/***/ }),

/***/ 53363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aj": function() { return /* binding */ orderEmailUsAnalytics; },
/* harmony export */   "Ex": function() { return /* binding */ addAnalyticsAccountSelection; },
/* harmony export */   "FS": function() { return /* binding */ downloadInvoiceAnalytics; },
/* harmony export */   "Gk": function() { return /* binding */ addAnalyticsOrderDetailConfirmation; },
/* harmony export */   "IH": function() { return /* binding */ addAnalyticsForCreateAccount; },
/* harmony export */   "Of": function() { return /* binding */ orderSupportLinkAnalytics; },
/* harmony export */   "a6": function() { return /* binding */ addAnalyticsgoToAccount; },
/* harmony export */   "bK": function() { return /* binding */ gtmPurchaseEvent; },
/* harmony export */   "eM": function() { return /* binding */ adobePurchaseEvent; },
/* harmony export */   "hV": function() { return /* binding */ getEventInfoForSignupPromotionalLinks; },
/* harmony export */   "m4": function() { return /* binding */ addAnalyticsForPasswordRequirementsLink; },
/* harmony export */   "ts": function() { return /* binding */ printOrderDetailConfirmation; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34326);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50361);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2__);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];




const getEventInfo = function(type) {
    let needJson = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const eventInfo = {
        eventAction: "my account:orders:order details:".concat(type),
        eventName: "my account:orders:order details:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "my orders",
        internalLinkType: "my account:".concat(type),
        internalLinkZoneName: "my account:orders:order details",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const getAccountType = (accountType)=>accountType === "homeowner" ? "homeowner account" : "professional account";
const getEventInfoForSignupPromotionalLinks = (url, type, accountType)=>{
    const account = getAccountType(accountType);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "order confirmation:create an account form:".concat(type),
        eventMsg: "n/a",
        eventName: "order confirmation:create an account form:".concat(type),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: type,
        internalLinkPosition: "order-confirmation",
        internalLinkType: "order confirmation:".concat(account),
        internalLinkURL: url,
        internalLinkZoneName: "order confirmation:create an account"
    };
    return JSON.stringify(eventInfo);
};
const addAnalyticsForCreateAccount = function(newsletterSignUp, accountType, url, eventStatus) {
    let message = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", email = arguments.length > 5 ? arguments[5] : void 0;
    const account = getAccountType(accountType);
    const internalLinkURL = url ? "".concat(window.location.origin).concat(url) : "n/a";
    const eventMsg = message ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.sanitizeTextForAnalytics)(message) : "n/a";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "order confirmation:".concat(account, ":create an account form"),
        eventMsg,
        eventName: "order confirmation:".concat(account, ":create an account form"),
        eventStatus,
        eventType: "navigation",
        internalLinkName: "create an account",
        internalLinkPosition: "order-confirmation",
        internalLinkType: "order confirmation:".concat(account),
        internalLinkURL,
        internalLinkZoneName: "order confirmation:create an account",
        newsletterSignUp
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const cloneObject = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2___default()(page);
    const base64Str = Buffer.from(email).toString("base64");
    cloneObject.user.commerceToolsID = base64Str;
    cloneObject.user.emailId = base64Str;
    pushAnalyticsObjToDataLayer(eventInfo, "cmp:click", cloneObject);
};
const addAnalyticsForPasswordRequirementsLink = function(accountType) {
    let isForOneClick = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const type = isForOneClick ? "order confirmation" : "my account modal section";
    const account = getAccountType(accountType);
    const internalLinkType = isForOneClick ? "order-confirmation:".concat(account) : "my account:navigation";
    const internalLinkZoneName = isForOneClick ? "order confirmation:create an account" : "my account:modal:sign in form";
    const internalLinkPosition = isForOneClick ? "order-confirmation" : "auth modal";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(type, ":").concat(account, ":password requirements"),
        eventMsg: "n/a",
        eventName: "".concat(type, ":").concat(account, ":password requirements"),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "password requirements",
        internalLinkPosition,
        internalLinkType,
        internalLinkURL: "n/a",
        internalLinkZoneName
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsgoToAccount = (accountPage)=>{
    const { adobeDataLayer: {} = {}  } = window;
    const eventInfo = {
        eventAction: "order:thank you: account",
        eventName: "order:thank you: account",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "account",
        internalLinkPosition: "order confirmation",
        internalLinkType: "order:navigation",
        internalLinkURL: accountPage,
        clickInternalLinks: "true",
        internalLinkZoneName: "order:thank you:order confirmation"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsOrderDetailConfirmation = (orderPage)=>{
    const { adobeDataLayer: {} = {}  } = window;
    const eventInfo = {
        eventAction: "orders:order confirmation:thank you for your order:view order details",
        eventName: "orders:order confirmation:thank you for your order:view order details",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view order details",
        internalLinkPosition: "order confirmation",
        internalLinkType: "order:navigation",
        internalLinkURL: orderPage,
        clickInternalLinks: "true",
        internalLinkZoneName: "orders:order confirmation:thank you for your order"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const printOrderDetailConfirmation = ()=>{
    const { adobeDataLayer: {} = {}  } = window;
    const eventInfo = {
        eventAction: "orders:order confirmation:thank you for your order:print order details",
        eventName: "orders:order confirmation:thank you for your order:print order details",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "print order details",
        internalLinkPosition: "order confirmation",
        internalLinkType: "order:navigation",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        internalLinkZoneName: "orders:order confirmation:thank you for your order"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsAccountSelection = (accountType)=>{
    const { adobeDataLayer: {} = {}  } = window;
    const eventInfo = {
        eventAction: "order confirmation: create a quick account: ".concat(accountType),
        eventName: "order confirmation: create a quick account: ".concat(accountType),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: accountType,
        internalLinkPosition: "order confirmation",
        internalLinkType: "order confirmation:create a quick account:navigation",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        internalLinkZoneName: "order confirmation:thank you: create a quick account"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, event = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "cmp:click", modifiedPageObj = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page: !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(modifiedPageObj) ? modifiedPageObj : page
    });
};
const downloadInvoiceAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:orders:order details:download invoice",
        eventName: "my account:orders:order details:download invoice",
        eventType: "navigation",
        internalLinkName: "download invoice",
        internalLinkPosition: "order details",
        internalLinkType: "my account:download",
        internalLinkURL: "n/a",
        internalLinkZoneName: "my account:orders:order details"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const orderSupportLinkAnalytics = (text, link)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:orders:order summary:".concat(text),
        eventName: "my account:orders:order summary:".concat(text),
        eventType: "navigation",
        internalLinkName: text,
        internalLinkPosition: "order details",
        internalLinkType: "my account:order support",
        internalLinkURL: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.getAnalyticLinkUrl)(link),
        internalLinkZoneName: "my account:orders:order summary"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const orderEmailUsAnalytics = function(text, link) {
    let isEmail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:orders:order summary:customer support ".concat(isEmail ? "email id" : "phone number"),
        eventName: "my account:orders:order summary:customer support ".concat(isEmail ? "email id" : "phone number"),
        eventType: "navigation",
        internalLinkName: text,
        internalLinkPosition: "order details",
        internalLinkType: "my account:customer support",
        internalLinkURL: link,
        internalLinkZoneName: "my account:orders:order summary"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const generateEventId = ()=>{
    return "".concat(Date.now(), "_").concat(Math.random().toString(36).slice(2));
};
const gtmPurchaseEvent = async function(id, email) {
    let address = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, total = arguments.length > 3 ? arguments[3] : void 0, _appliedCouponCode = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    const eventId = generateEventId();
    if ( true && window.dataLayer) {
        const { phone , firstName , lastName , streetName , city , region , postalCode  } = address;
        window.dataLayer.push({
            event: "ec_purchase",
            event_id: eventId,
            email,
            sha256_email_address: await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.shaEncrypt)(email),
            phone_number: "+91".concat(phone),
            sha256_phone_number: await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.shaEncrypt)(phone),
            address: {
                first_name: firstName,
                sha256_first_name: await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.shaEncrypt)(firstName),
                last_name: lastName,
                sha256_last_name: await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.shaEncrypt)(lastName),
                street: streetName,
                city: city,
                region: region,
                postal_code: postalCode,
                country: "IN"
            },
            order_value: total,
            order_id: id,
            coupon_code: _appliedCouponCode
        });
        const eventTime = Math.floor(Date.now() / 1000);
        const anonymousId = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.getAnonymousId)();
        const oktaToken = localStorage.getItem("okta-token-storage");
        let emailId = "";
        if (oktaToken && oktaToken !== "{}") {
            var ref;
            const oktaObject = JSON.parse(oktaToken);
            const claim = (oktaObject === null || oktaObject === void 0 ? void 0 : (ref = oktaObject.accessToken) === null || ref === void 0 ? void 0 : ref.claims) || {};
            emailId = claim === null || claim === void 0 ? void 0 : claim.sub;
        }
        await fetch("https://graph.facebook.com/v25.0/".concat("331133875864147", "/events?access_token=").concat("EAAaqfp2QIY4BRqxJg2gSPHX5fa8LgtuyQauj2XcDverFLHiK79oCTD9HIgolAYlt7gb0qNXiXkZBZBhBrv9X9AC1kjvO7ZBvFOIBp0vbHjJK4MTWy0ym4CB2pyI7DfFJzl0I8NeOsJw1gt8aQlgfIyuNWbouhpuhloVMODFZAVhuha9bEmxAOZA2P1ZBeZA4frodgZDZD"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                data: [
                    {
                        event_name: "Purchase",
                        event_time: eventTime,
                        event_id: eventId,
                        action_source: "website",
                        "user_data": {
                            "client_user_agent": navigator.userAgent,
                            em: [
                                await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.shaEncrypt)(emailId.toLowerCase())
                            ]
                        },
                        custom_data: {
                            email,
                            sha256_email_address: await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.shaEncrypt)(email),
                            phone_number: "+91".concat(phone),
                            sha256_phone_number: await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.shaEncrypt)(phone),
                            address: {
                                first_name: firstName,
                                sha256_first_name: await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.shaEncrypt)(firstName),
                                last_name: lastName,
                                sha256_last_name: await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.shaEncrypt)(lastName),
                                street: streetName,
                                city: city,
                                region: region,
                                postal_code: postalCode,
                                country: "IN"
                            },
                            order_value: total,
                            order_id: id,
                            coupon_code: _appliedCouponCode
                        }
                    }
                ]
            })
        });
    }
};
const calDisBasePriceLineItm = (item_cent, discountedBasePrice, couponDiscount)=>{
    var ref, ref1;
    const item_price_rupee = ((ref = item_cent.price) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.centAmount) / 100;
    if (couponDiscount > 0) {
        const basePrice = discountedBasePrice + couponDiscount;
        const discount_percentage = couponDiscount / basePrice * 100;
        return item_price_rupee - item_price_rupee * discount_percentage / 100;
    } else {
        return item_price_rupee;
    }
};
const adobePurchaseEvent = async (rsp)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const _discountedBasePrice = (rsp === null || rsp === void 0 ? void 0 : (ref = rsp.totalPrice) === null || ref === void 0 ? void 0 : ref.centAmount) / 100;
    const _couponDiscount = (rsp === null || rsp === void 0 ? void 0 : (ref1 = rsp.discountOnTotalPrice) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.discountedAmount) === null || ref2 === void 0 ? void 0 : ref2.centAmount) / 100;
    const getAttr = (product, key)=>{
        const data = product.variant.attributes.find((item)=>item.name === key);
        return data === null || data === void 0 ? void 0 : data.value;
    };
    const eventInfo = {
        orderID: rsp.id,
        orderNumber: rsp.orderNumber,
        price: {
            basePrice: _discountedBasePrice,
            voucherCode: "n/a",
            voucherDiscount: 0,
            globalOffer: "n/a",
            globalDiscount: 0,
            currency: "inr",
            taxRate: 0,
            shipping: 0,
            priceWithTax: ((ref3 = rsp.totalPrice) === null || ref3 === void 0 ? void 0 : ref3.centAmount) / 100,
            cartTotal: ((ref4 = rsp.totalPrice) === null || ref4 === void 0 ? void 0 : ref4.centAmount) / 100,
            couponCode: "n/a",
            couponDiscount: _couponDiscount,
            orderCouponCode: "n/a",
            orderCouponDiscount: 0,
            shippingMethod: "standard"
        },
        item: (ref5 = rsp.lineItems) === null || ref5 === void 0 ? void 0 : ref5.map((item)=>{
            var ref, ref1, ref2, ref3, ref4;
            return {
                productInfo: {
                    productBrand: "kohler-india",
                    productID: (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku,
                    description: getAttr(item, "ProductDescriptionProduct"),
                    productCategory: getAttr(item, "ProductLocalCategory"),
                    productName: getAttr(item, "ProductBrandNameDisplay"),
                    productColor: "thunder grey",
                    productRoom: "non-catalog",
                    productSaleable: true,
                    productStatus: "in stock",
                    productPartnerBuyNow: false,
                    productBasePrice: calDisBasePriceLineItm(item, _discountedBasePrice, _couponDiscount),
                    productCouponCode: "n/a",
                    productCoupondiscount: 0,
                    productSuperSku: false,
                    productSalePrice: ((ref1 = item.price) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.centAmount) / 100,
                    globalPromotionPrice: ((ref3 = item.price) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.value) === null || ref4 === void 0 ? void 0 : ref4.centAmount) / 100,
                    priceState: "regular price",
                    productCollectionsName: getAttr(item, "ProductBrandName"),
                    productFindingMethod: "n/a",
                    productTileName: getAttr(item, "ProductBrandName"),
                    quantity: item.quantity,
                    globalOffer: "n/a",
                    globalDiscount: 0,
                    itemType: "product",
                    isSubscription: false,
                    isRecommended: false,
                    frequency: "n/a",
                    isSendNow: "n/a",
                    ratings: "n/a",
                    numberOfReviews: "n/a",
                    pdpType: "regular finished goods & service parts"
                },
                quantity: item.quantity
            };
        })
    };
    pushAnalyticsObjToDataLayer(eventInfo, "cmp:purchase");
};



/***/ }),

/***/ 24071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ OrderSummaryItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57333);
/* harmony import */ var _components_core_ToolTip_ToolTip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45138);




const OrderSummaryItem = (param)=>{
    let { label , value , icon , children , id , prefix ="" , freeShipping =null , tooltip =null , alt ="" , role ="" , customCls ="" , valueSize ="" , onClick =()=>{} , decimalScale =2 , onMouseOver , type  } = param;
    const [tooltipFlag, setTooltipFlag] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const keyProp = id ? {
        key: id
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            ...keyProp,
            className: "order-summary__item  ".concat(customCls),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "order-summary__item--label",
                    children: [
                        label && label,
                        icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: icon,
                            role: role !== null && role !== void 0 ? role : "tooltip",
                            margin: "unset",
                            alt: alt,
                            className: "order-summary__tooltip-icon",
                            onMouseOver: ()=>{
                                setTooltipFlag(true);
                                onMouseOver(type);
                            },
                            onMouseOut: ()=>setTooltipFlag(false),
                            onClick: onClick
                        }),
                        children && children,
                        tooltip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "order-summary__tooltip--".concat(tooltipFlag ? "show" : "hide"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "order-summary__tooltip-wrapper",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_ToolTip_ToolTip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    message: tooltip
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "order-summary__item--value".concat(valueSize ? "-".concat(valueSize) : ""),
                    children: !isNaN(value) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_2__/* .NumericFormat */ .h3, {
                        value: parseFloat(value !== null && value !== void 0 ? value : 0).toFixed(decimalScale),
                        displayType: "text",
                        thousandSeparator: true,
                        prefix: prefix !== null && prefix !== void 0 ? prefix : "",
                        thousandsGroupStyle: "lakh"
                    }) : value
                })
            ]
        })
    });
};


/***/ }),

/***/ 96514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jk": function() { return /* binding */ addCartItemSummaryAnalytics; },
/* harmony export */   "UN": function() { return /* binding */ addRemoveProductFromCartAnalytics; },
/* harmony export */   "u$": function() { return /* binding */ analyticsCB; },
/* harmony export */   "uU": function() { return /* binding */ calculateCartAnalytics; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34326);

const analyticsCB = function(status) {
    let cartObj = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const page = window.pageObj || {};
    if (status !== "success" && page.eventInfo) {
        page.eventInfo.eventStatus = "failure";
        page.eventInfo.eventMsg = status || "failed to update item(s) in cart.";
        const otherItems = {};
        if (page.updatedSku) {
            var ref, ref1;
            // get productInfo and add to event page objet.
            const matchingSku = (ref = page.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.find((prod)=>{
                var ref, ref1;
                return ((ref = prod.productInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.productID) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === page.updatedSku.toLowerCase();
            });
            if (matchingSku) {
                otherItems.productInfo = matchingSku.productInfo;
            }
        }
        otherItems.eventInfo = page.eventInfo;
        delete page.eventInfo;
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            ...otherItems
        });
    } else if (page.eventInfo && cartObj) {
        calculateCartAnalytics({
            cart: cartObj,
            eventName: "cmp:click"
        });
    }
};
const calculateCartAnalytics = (param)=>{
    let { cart , eventName ="cmp:show"  } = param;
    const page = window.pageObj || {};
    page.cart = cart;
    page.user = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.getUserAnalyticsObject)();
    if (eventName === "cmp:show" && page.user && (!page.user.gId || page.user.gId === "n/a") && (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")) {
        window.pageObj = page;
        window.isShowAnalyticsEvent = true;
    } else if (eventName === "cmp:show" && !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.isShowAnalyticsEventLoaded)() || eventName !== "cmp:show") {
        let otherItems = {};
        if (eventName !== "cmp:show") {
            var ref;
            if (page.eventInfo) {
                otherItems = {
                    eventInfo: page.eventInfo
                };
                delete page.eventInfo;
            }
            const matchedItem = cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.find((prod)=>{
                var ref;
                return ((ref = prod.productInfo) === null || ref === void 0 ? void 0 : ref.productUpdated) === true;
            });
            if (matchedItem) {
                // here check initialQuantity from oldCart object.
                if (window.oldValue) {
                    matchedItem.productInfo.initialQuantity = window.oldValue;
                    delete window.oldValue;
                }
                otherItems.productInfo = matchedItem.productInfo;
            }
        }
        window.adobeDataLayer.push({
            event: eventName,
            page,
            ...otherItems
        });
    }
};
const addCartItemSummaryAnalytics = function(page, prodDesc, prodName, pdpNavigationURL) {
    let itemName = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "".concat(page !== "cart" && page !== "checkout" ? "my account:orders:order details" : page === "cart" ? "cart preview" : page, ":product navigation"),
        eventMsg: "n/a",
        eventName: "".concat(page !== "cart" && page !== "checkout" ? "my account:orders:order details" : page === "cart" ? "cart preview" : page, ":product navigation"),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: itemName,
        internalLinkPosition: page !== "cart" && page !== "checkout" ? "my order" : page,
        internalLinkType: "".concat(page !== "cart" && page !== "checkout" ? "my account" : page, ":navigation"),
        internalLinkURL: pdpNavigationURL ? ((pdpNavigationURL === null || pdpNavigationURL === void 0 ? void 0 : pdpNavigationURL.indexOf("http")) === -1 ? window.location.origin : "") + pdpNavigationURL : "n/a",
        internalLinkZoneName: page !== "cart" && page !== "checkout" ? "my account:orders:order details" : page + ":preview"
    });
};
const addRemoveProductFromCartAnalytics = (action, data)=>{
    var ref, ref1, ref2, ref3;
    const eventInfo = {
        eventAction: "cart:landing page:remove",
        eventName: "cart:landing page:remove",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "remove",
        internalLinkPosition: "cart",
        internalLinkType: "cart:navigation",
        internalLinkZoneName: "cart:landing page:cart items",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    sessionStorage.setItem("cartLanding", eventInfo.searchCount);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const removedItem = page === null || page === void 0 ? void 0 : (ref = page.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.find((item)=>item.productInfo.productID === data.sku);
    const updatedPage = page === null || page === void 0 ? void 0 : (ref2 = page.cart) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.item) === null || ref3 === void 0 ? void 0 : ref3.filter((item)=>{
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.productInfo) === null || ref === void 0 ? void 0 : ref.productID) !== data.sku;
    });
    if (page && page.cart && page.cart.item) {
        page.cart.item = updatedPage;
    }
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo,
        productInfo: removedItem === null || removedItem === void 0 ? void 0 : removedItem.productInfo
    });
};


/***/ }),

/***/ 96005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95357);
/* harmony import */ var _components_Shared_ProductSocialShare_v1_ProductSocialShare__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13678);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34326);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20558);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88751);












const PartsViewer = (param)=>{
    let { page ="" , i18n ={} , productId ="" , partId ="" , analyticsCustomData =null , onClose , showModal =false  } = param;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    const iframeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    const [svgViewerPath, setSvgViewerPath] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [currencySign, setCurrencySign] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [general, setGeneral] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [plpServletPath, setPlpServletPath] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [salesChannelConfig, setSalesChannelConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)().then(async (config)=>{
            var ref;
            const svgViewerPath = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.getShortenedUrl)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(config, "general.svgViewerPath", ""));
            var ref1;
            setSalesChannelConfig((ref1 = config === null || config === void 0 ? void 0 : (ref = config.salesChannelConfig) === null || ref === void 0 ? void 0 : ref.map) !== null && ref1 !== void 0 ? ref1 : {});
            const currencySign = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(config, "internationalization.currencySign", "");
            setCurrencySign(currencySign);
            setSvgViewerPath(svgViewerPath);
            setGeneral(config.general);
            setPlpServletPath(config.plpServletPath);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showModal) {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.preventBodyScroll)(true);
        }
    }, [
        showModal
    ]);
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.getUserPersona)();
    const [showShare, setShowShare] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const getPDPUrlForViewer = (category, slug)=>{
        const pdpdUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.getPDPUrlWithConfig)(category, slug, plpServletPath, general);
        return pdpdUrl;
    };
    const addToCartTrigger = async (data)=>{
        const actions = [];
        data.forEach((product)=>{
            var ref;
            const fields = {
                salesChannel: (ref = salesChannelConfig[product === null || product === void 0 ? void 0 : product.brand]) !== null && ref !== void 0 ? ref : "KOUS"
            };
            actions.push({
                action: product.isBundle ? "addbundle" : "addLineItem",
                sku: product.sku,
                quantity: product.quantity,
                custom: {
                    type: {
                        key: "lineItemShipping"
                    },
                    fields: fields
                }
            });
        });
        const reqData = {};
        reqData["actions"] = actions;
        const cartObj = dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_11__/* .searchPlp */ .tK)(reqData)).unwrap().then((res)=>{
            const respVal = {};
            respVal.status = 200;
            return respVal;
        }).catch((err)=>{
            const respVal = {};
            respVal.status = 500;
            return respVal;
        }) || {};
        return cartObj;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (currencySign !== "" && persona && plpServletPath && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(general)) {
            var ref;
            window.partViewer = {
                atc: addToCartTrigger,
                getPDPUrl: getPDPUrlForViewer,
                persona,
                currencySign,
                setShowShare
            };
            (ref = iframeRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            return ()=>(0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.preventBodyScroll)(false);
        }
    }, [
        currencySign,
        persona,
        general
    ]);
    const filename = (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .getExtention */ .fN)(partId) ? partId : partId + ".svg";
    const closeModal = ()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__.preventBodyScroll)(false);
        onClose();
    };
    const getPartDiagramCloseEventInfo = JSON.stringify({
        eventAction: page + ":modal:interactive parts diagram:close",
        eventName: page + ":modal:interactive parts diagram:close",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: page,
        internalLinkType: page + ":close",
        internalLinkZoneName: page + ":modal:interactive parts diagram",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        showModal: showModal,
        onModalClose: closeModal,
        closeButtonAnalytics: getPartDiagramCloseEventInfo,
        analyticsCustomData: analyticsCustomData || null,
        children: [
            svgViewerPath && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                id: "svg-viewer-iframe",
                ref: iframeRef,
                allowFullScreen: true,
                scrolling: "auto",
                src: "".concat(svgViewerPath, "?productId=").concat(productId, "&filename=").concat(filename, "&diagram=0&origin=").concat(window.location.href)
            }),
            showShare && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PartSocialShare, {
                showShare: showShare,
                setShowShare: setShowShare,
                iframeId: "svg-viewer-iframe",
                i18n: i18n,
                iframeRef: iframeRef.current
            })
        ]
    });
};
const PartSocialShare = (param)=>{
    let { showShare , setShowShare , iframeId , i18n , iframeRef  } = param;
    return /*#__PURE__*/ react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_ProductSocialShare_v1_ProductSocialShare__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        showModal: showShare,
        id: "social-share-iframe",
        onClose: ()=>setShowShare(false),
        iframeId: iframeId,
        iframeRef: iframeRef,
        disableInstagram: true,
        mailSubject: i18n.mailSubject,
        mailBody: i18n.mailBody
    }), iframeRef.contentDocument.getElementById("social-share-gbh"));
};
/* harmony default export */ __webpack_exports__["Z"] = (PartsViewer);


/***/ }),

/***/ 4421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_core_Radio_Radio_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72883);
/* harmony import */ var _components_core_Radio_Radio_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_components_core_Radio_Radio_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var _tabIndex, _role, _ariaLabel, _disabled;
const Radio = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_core_Radio_Radio_module_scss__WEBPACK_IMPORTED_MODULE_3___default().radioButtonWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
            "aria-checked": props.checked,
            tabIndex: (_tabIndex = props.tabIndex) !== null && _tabIndex !== void 0 ? _tabIndex : 0,
            role: (_role = props.role) !== null && _role !== void 0 ? _role : "radio",
            "aria-label": (_ariaLabel = props.ariaLabel) !== null && _ariaLabel !== void 0 ? _ariaLabel : props.label,
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
                "radio-button": true,
                "--black": props.type === "black",
                "--disabled": (_disabled = props.disabled) !== null && _disabled !== void 0 ? _disabled : false
            }),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    type: "radio",
                    name: props.name,
                    value: props.value,
                    onClick: (e)=>props.onSelect(e),
                    defaultChecked: props.checked,
                    disabled: props.disabled
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "radio-button__marker",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "radio-button__checked"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "radio-button__label",
                    children: props.label
                })
            ]
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (Radio);


/***/ }),

/***/ 72883:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radioButtonWrapper":"Radio_radioButtonWrapper__Mk6KF"};

/***/ })

}]);